var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sav-spinner",class:_vm.moreClass},[_vm._v("Loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }